export const DATE_RE = new RegExp(
  [
    "\\b\\d{4}-\\d{2}-\\d{2}\\b",
    "\\b\\d{1,2}[/.-]\\d{1,2}[/.-]\\d{2,4}\\b",
    "\\b(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec)[a-z]*\\.?\\s+\\d{1,2}(?:st|nd|rd|th)?,?\\s+\\d{4}\\b",
    "\\b\\d{1,2}\\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\\s+\\d{4}\\b",
  ].join("|"),
  "i",
);
export const REF_RE =
  /\b(?:ref(?:erence)?|case|file|invoice|inv|tracking|claim|order|docket|ticket|po)\s*(?:no\.?|number|#)?\s*[:#]?\s*([A-Z0-9][A-Z0-9-]{2,})/i;

export function summarize(raw = "", ref = "") {
  const body = raw.replace(/^\[Scanned from .*\]$/gm, "");
  const clean = body.replace(/\[\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\]/g, " ").replace(/^#+\s.*$/gm, " ").replace(/^\s*(?:\d+[.)]|[-*•])\s+/gm, "").replace(/\s+/g, " ").trim();
  const sentence = (clean.match(/.+?(?:[.!?](?=\s|$)|$)/) || [""])[0].trim().slice(0, 160);
  const date = (body.match(DATE_RE) || [""])[0];
  const refMatch = body.match(REF_RE);
  return { sentence, date, ref: ref || (refMatch ? refMatch[1] : "") };
}
